import { render, staticRenderFns } from "./PhoneNumberField.vue?vue&type=template&id=2e437e98&scoped=true&lang=pug&"
import script from "./PhoneNumberField.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberField.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberField.vue?vue&type=style&index=0&id=2e437e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e437e98",
  null
  
)

export default component.exports